'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _format2 = require('../../helpers/format');

var _format3 = _interopRequireDefault(_format2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link, LinkIcon } from '../'

var EsgConfig = {
  esgNamesLabels: [{
    label: 'Overall exposure',
    value: 't_all_weight'
  }, {
    label: 'Tobacco producers',
    value: 'to_weight'
  }, {
    label: 'Tobacco-promoting entertainment companies',
    value: 'tm_weight'
  }],
  esgOptions: {
    t_all_weight: {
      id: 't_all_weight',
      icon: 'icons_step4',
      fieldLabel: 't_all_weight',
      benchLabel: 't_all_weight',
      valueLabel: 'Overall exposure',
      direction: 'ascending',
      page: 'all-company-investments',
      label: 'in tobacco and tobacco-promoting entertainment companies',
      units: null,
      unitsExpanded: null,
      diffGood: function diffGood(diff) {
        return diff < 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-bad' : 'lower-good';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'More invested' : 'Less invested';
      },
      format: function format(val) {
        return _format3.default.perc(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (val === 0) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same amount'
            ),
            ' invested in tobacco and tobacco-promoting entertainment companies'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            _format3.default.perc(val),
            ' ',
            moreLess
          ),
          ' invested in tobacco and tobacco-promoting entertainment companies'
        );
      }
    },
    to_weight: {
      id: 'to_weight',
      icon: 'icons_step4',
      fieldLabel: 'to_weight',
      benchLabel: 'to_weight',
      valueLabel: 'Tobacco producers',
      direction: 'ascending',
      page: 'tobacco-company-investments',
      label: 'in tobacco producers',
      units: null,
      unitsExpanded: null,
      diffGood: function diffGood(diff) {
        return diff < 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-bad' : 'lower-good';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'More invested' : 'Less invested';
      },
      format: function format(val) {
        return _format3.default.perc(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (val === 0) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same amount'
            ),
            ' invested in tobacco producers'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            _format3.default.perc(val),
            ' ',
            moreLess
          ),
          ' invested in tobacco producers'
        );
      }
    },
    tm_weight: {
      id: 'tm_weight',
      icon: 'icons_step4',
      fieldLabel: 'tm_weight',
      benchLabel: 'tm_weight',
      valueLabel: 'Tobacco-promoting entertainment companies',
      direction: 'ascending',
      page: 'entertainment-company-investments',
      label: 'in tobacco-promoting entertainment companies',
      units: null,
      unitsExpanded: null,
      diffGood: function diffGood(diff) {
        return diff < 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-bad' : 'lower-good';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'More invested' : 'Less invested';
      },
      format: function format(val) {
        return _format3.default.perc(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (val === 0) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same amount'
            ),
            ' invested in tobacco-promoting entertainment companies'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            _format3.default.perc(val),
            ' ',
            moreLess
          ),
          ' invested in tobacco-promoting entertainment companies'
        );
      }
    }
  }
};
// import config from '../../config'
exports.default = EsgConfig;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EsgConfig/EsgConfig.js
// module id = 1273
// module chunks = 0